/**
 * @prettier
 */

import React from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';
import onboardTrackingConstants from '@zola-helpers/client/dist/es/tracking/onboard/onboardTrackingConstants';
import { getCardCatalogBusy } from '~/cards/selectors/cardCatalogSelector';
import { getMultiSampleState } from '~/cards/selectors/samples';
import { setMultiSampleEnabled as setMultiSampleEnabledAction } from '~/cards/actions/samples';
import ToggleV2 from '@zola/zola-ui/src/components/ToggleV2';
import { trackEvent } from '@zola-helpers/client/dist/es/tracking/trackingHelper';
import styles from './styles.module.less';

const { BUSINESS_UNIT } = onboardTrackingConstants;

export const ToggleBase = ({
  cardCatalogBusy,
  cardType,
  multiSampleState,
  setMultiSampleEnabled,
  scrollToTop,
}) => {
  return (
    <div className={cx(styles.toggle, styles.prominentToggle)}>
      <ToggleV2
        id="multi-samples-toggle"
        ariaLabel="Select multi sample"
        withIcons
        input={{
          value: multiSampleState.enabled,
          onChange: () => {
            if (cardCatalogBusy) {
              return;
            }

            if (!multiSampleState.enabled) {
              trackEvent('CTA Clicked', {
                business_unit: BUSINESS_UNIT.INVITATIONS,
                cta_type: 'TOGGLE',
                cta: 'PICK_FREE_SAMPLE_DESIGNS',
              });
            }

            if (scrollToTop) {
              scrollToTop();
            }
            setMultiSampleEnabled(cardType, !multiSampleState.enabled);
          },
        }}
      />
    </div>
  );
};

export const mapStateToProps = (state) => ({
  cardCatalogBusy: getCardCatalogBusy(state),
  multiSampleState: getMultiSampleState(state),
});

export const mapDispatchToProps = (dispatch) => ({
  setMultiSampleEnabled: (cardType, enabled) =>
    dispatch(setMultiSampleEnabledAction(cardType, enabled)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ToggleBase);
